import { appPaths } from '@terminal/routes/app-paths';
import {
  appendChartAssetParam,
  ChartSearchParamsAssetValue,
} from '@terminal/utils/chart-search-utils/chart-search-utils';
import { ChartState } from '@terminal/views/turbo-chart/hooks/use-chart-state/useChartState';
import {
  COMMANDER_OPEN_TURBO_CUSTOM_EVENT,
  CommanderOpenTurboEvent,
  PaneSettings,
} from '@terminal/views/turbo-chart/utils/chart-settings-utils/chart-settings-utils';
import { useNavigate } from 'react-router';

export type ChartNavigateConfigParams = Partial<
  Omit<ChartState, 'chartPanes'> & PaneSettings
>;

export type NavigateToChartParams = {
  assets: ChartSearchParamsAssetValue[];
  configParams?: ChartNavigateConfigParams;
  isOnChartPage?: boolean;
  replace?: boolean;
};

export const useChartNavigate = () => {
  const navigate = useNavigate();

  const navigateToChart = ({
    assets,
    configParams,
    isOnChartPage = false,
    replace = false,
  }: NavigateToChartParams) => {
    const searchParams = new URLSearchParams();

    assets.forEach(asset => {
      appendChartAssetParam(searchParams, asset);
    });
    configParams &&
      Object.keys(configParams).forEach(key => {
        const value = configParams[key as keyof ChartNavigateConfigParams];

        if (value) {
          searchParams.append(key, value.toString());
        }
      });
    const to = {
      pathname: appPaths.chart,
      search: searchParams.toString(),
    };

    navigate(to, { replace });

    if (isOnChartPage) {
      document.dispatchEvent(
        new CustomEvent(COMMANDER_OPEN_TURBO_CUSTOM_EVENT, {
          detail: {
            searchParams,
          },
        }) as CommanderOpenTurboEvent
      );
    }
  };

  return navigateToChart;
};
